import styles from "./Tools.module.css";
import SectionHeader from "shared/components/Header/SectionHeader";
import ToolCard from "shared/components/ToolCard";
import { useFetch } from "shared/utils/useFetch";

const Tools = () => {
  const { data: tools } = useFetch("/api/tools", []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <SectionHeader title="Top-Tier Tools for Exceptional Results" />
        <div className={styles.toolsContainer}>
          {tools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tools;
